import { render, staticRenderFns } from "./index.vue?vue&type=template&id=648100c3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=648100c3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648100c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/卡百利业务中台2.0（前端）生产环境/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648100c3')) {
      api.createRecord('648100c3', component.options)
    } else {
      api.reload('648100c3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=648100c3&scoped=true", function () {
      api.rerender('648100c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/VabBreadcrumb/index.vue"
export default component.exports